import { render, staticRenderFns } from "./TodoListIndex.vue?vue&type=template&id=d85d5f26"
import script from "./TodoListIndex.vue?vue&type=script&lang=js"
export * from "./TodoListIndex.vue?vue&type=script&lang=js"
import style0 from "./TodoListIndex.vue?vue&type=style&index=0&id=d85d5f26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports